import React from 'react';

import { DoubleTextNodeClamp } from '@components/common';
import ChangedField from '@components/common/ChangedField';
import FilesListChanged from '@components/common/FilesListChanged/FilesListChanged';

import { getCheckIcon } from '@utils/tableUtils';

import { IAssetFile } from '@interfaces/assets/asset';

import { EBackhaulA11yStatus } from '@enums/map';

import styles from './AttributeCardChanged.module.scss';

type TChangedFile = {
	current: IAssetFile;
	previous: IAssetFile;
	isChanged: boolean;
	testId?: string;
};

interface IAttributeCardProps {
	detailsName?: Record<string, any> | null;
	title: string;
	fileFieldName?: Record<string, any> | null;
	options: Record<string, any>;
}

const AttributeCard = ({ detailsName, fileFieldName, options, title }: IAttributeCardProps) => {
	const { current: currentOption, previous: previousOptions, isChanged: optionChanged } = options;
	const fileList: TChangedFile[] | null = fileFieldName ? Object.values(fileFieldName) : null;
	const fieldChanged = optionChanged && !!previousOptions;

	const getIconFromOption = (option: any, isChanged: boolean) => {
		if (!option) return null;

		const icon = getCheckIcon(EBackhaulA11yStatus, option?.value);

		return icon
			? <>{icon}{isChanged ? option.label : ''}</>
			: <>{option.label}</>;
	};

	const currentIcon = getIconFromOption(currentOption, fieldChanged);
	const previousIcon = getIconFromOption(previousOptions, fieldChanged);

	return (
		<div className={styles.attributeCardContainer}>
			<div className={styles.title}>
				<div className={styles.bold}>{title}</div>
				<ChangedField
					current={currentIcon}
					isChanged={fieldChanged}
					previous={previousIcon}
					testId={options.testId}
				/>
			</div>
			{detailsName && (
				<>
					<div className={styles.subTitle}>Details</div>
					<div className={styles.details}>
						<DoubleTextNodeClamp
							current={detailsName?.current}
							isChanged={!!detailsName?.isChanged}
							previous={detailsName?.previous}
						/>
					</div>
				</>
			)}
			{(!!fileList?.length) && (
				<div>
					<div className={styles.subTitle}>Attached files</div>
					<FilesListChanged files={fileList as TChangedFile[]} />
				</div>
			)}
		</div>
	);
};

export default AttributeCard;
